module.exports = __webpack_public_path__ + "img/news6-1.c58af54f.png";